/**
 * Iframe Block — click-to-play for poster mode.
 * Replaces the poster image with the iframe when the user clicks.
 */
document.querySelectorAll( '.iframe-poster-wrap' ).forEach( ( wrap ) => {
	wrap.addEventListener( 'click', () => {
		const src = wrap.dataset.src;
		if ( ! src ) return;

		// Build autoplay URL
		let autoplaySrc = src;
		if ( src.includes( 'youtube.com' ) || src.includes( 'youtu.be' ) ) {
			autoplaySrc = src + ( src.includes( '?' ) ? '&' : '?' ) + 'autoplay=1&rel=0';
		} else if ( src.includes( 'vimeo.com' ) ) {
			autoplaySrc = src + ( src.includes( '?' ) ? '&' : '?' ) + 'autoplay=1';
		}

		const iframe = document.createElement( 'iframe' );
		iframe.src = autoplaySrc;
		iframe.title = wrap.closest( '.iframe-block-wrapper' )?.querySelector( 'img' )?.alt || 'Video';
		iframe.frameBorder = '0';
		iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
		iframe.allowFullscreen = true;
		iframe.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;border:none;display:block;';

		const container = wrap.parentElement;
		container.style.position = 'relative';
		wrap.replaceWith( iframe );
	} );
} );
